import { BaseService } from './BaseService';
import { Macro } from '../models/Macro';

// Macro Service
export class MacroService extends BaseService {
  constructor() {
    super();
  }

  // Fetch all macros for current user
  async getMacros() {
    const data = await this.get('/macros');
    // Expect { macros: [...] }
    const list = Array.isArray(data.macros) ? data.macros : [];
    return list.map(item => new Macro(item));
  }

  // Create a new macro – expects a Macro-like object: { keyword, expansionText }
  async createMacro(macroData) {
    const data = await this.post('/macros', macroData);
    return data.macro ? new Macro(data.macro) : null;
  }

  // Update existing macro by id – body can contain keyword, expansionText
  async updateMacro(id, updates) {
    if (!id) throw new Error('Macro ID is required');
    const data = await this.put(`/macros/${id}`, updates);
    return data.macro ? new Macro(data.macro) : null;
  }

  // Delete macro by id. API uses POST /macros/delete/:id
  async deleteMacro(id) {
    if (!id) throw new Error('Macro ID is required');
    return this.post(`/macros/delete/${id}`, {});
  }
}
